import { render } from "./InfoBar.vue?vue&type=template&id=39faf627&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"

import "./InfoBar.vue?vue&type=style&index=0&id=39faf627&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39faf627"]])

export default __exports__